__turbopack_context__.v({
  "assistant": "HeroChat-module__HiTaVG__assistant",
  "chatCta": "HeroChat-module__HiTaVG__chatCta",
  "chatCtaBlock": "HeroChat-module__HiTaVG__chatCtaBlock",
  "chatCtaNote": "HeroChat-module__HiTaVG__chatCtaNote",
  "chatGrid": "HeroChat-module__HiTaVG__chatGrid",
  "chatMode": "HeroChat-module__HiTaVG__chatMode",
  "chip": "HeroChat-module__HiTaVG__chip",
  "chips": "HeroChat-module__HiTaVG__chips",
  "close": "HeroChat-module__HiTaVG__close",
  "composer": "HeroChat-module__HiTaVG__composer",
  "conversation": "HeroChat-module__HiTaVG__conversation",
  "disclaimer": "HeroChat-module__HiTaVG__disclaimer",
  "disclaimerLink": "HeroChat-module__HiTaVG__disclaimerLink",
  "error": "HeroChat-module__HiTaVG__error",
  "experience": "HeroChat-module__HiTaVG__experience",
  "hasProposal": "HeroChat-module__HiTaVG__hasProposal",
  "heroChat": "HeroChat-module__HiTaVG__heroChat",
  "message": "HeroChat-module__HiTaVG__message",
  "messages": "HeroChat-module__HiTaVG__messages",
  "module": "HeroChat-module__HiTaVG__module",
  "moduleGrid": "HeroChat-module__HiTaVG__moduleGrid",
  "open": "HeroChat-module__HiTaVG__open",
  "promptHeadline": "HeroChat-module__HiTaVG__promptHeadline",
  "promptInput": "HeroChat-module__HiTaVG__promptInput",
  "proposal": "HeroChat-module__HiTaVG__proposal",
  "proposalActions": "HeroChat-module__HiTaVG__proposalActions",
  "proposalEyebrow": "HeroChat-module__HiTaVG__proposalEyebrow",
  "proposalHeader": "HeroChat-module__HiTaVG__proposalHeader",
  "proposalInner": "HeroChat-module__HiTaVG__proposalInner",
  "proposalJump": "HeroChat-module__HiTaVG__proposalJump",
  "proposalNote": "HeroChat-module__HiTaVG__proposalNote",
  "proposalPrimary": "HeroChat-module__HiTaVG__proposalPrimary",
  "proposalReset": "HeroChat-module__HiTaVG__proposalReset",
  "proposalTitle": "HeroChat-module__HiTaVG__proposalTitle",
  "questionsCard": "HeroChat-module__HiTaVG__questionsCard",
  "replyOption": "HeroChat-module__HiTaVG__replyOption",
  "replyOptions": "HeroChat-module__HiTaVG__replyOptions",
  "send": "HeroChat-module__HiTaVG__send",
  "step": "HeroChat-module__HiTaVG__step",
  "summaryCard": "HeroChat-module__HiTaVG__summaryCard",
  "timeline": "HeroChat-module__HiTaVG__timeline",
  "typing": "HeroChat-module__HiTaVG__typing",
  "typing-bounce": "HeroChat-module__HiTaVG__typing-bounce",
  "user": "HeroChat-module__HiTaVG__user",
});
